import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';

import { ValidarUsuarioDto } from 'src/app/feature/autenticacion/dto/validarUsuarioDto';
import { GenericDto } from '../data/GenericDto';
import { constantes } from '../data/Constantes';
import { SessionDto } from '../data/SessionDto';
import { LoginDto } from '../../feature/autenticacion/dto/LoginDto';
import { ActualizarContraseñaDto } from 'src/app/feature/autenticacion/dto/ActualizarContraseñaDto';

@Injectable({
  providedIn: 'root'
})
export class LoginRequestService {

  respuesta = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8' }),
  };

  constructor(private http: HttpClient) { }

  public consultarInformacionUsuario(sessionDto: SessionDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.CONSULTAR_INFORMACION_USUARIO, sessionDto, this.respuesta);
  }

  public validarSessionActiva(codigoUsuario: number, session: number): Observable<any> {
    return this.http.get<any>(environment.api + constantes.VALIDAR_SESSION_ACTIVA + `/${codigoUsuario}/${session}`);
  }

  public loginRedireccionado(LoginDto: LoginDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.LOGIN_REDIRECCIONADO,LoginDto, this.respuesta);
  }

  public login(usuario: string, contrasena: string): Observable<GenericDto> {
    return this.http.get<GenericDto>(environment.api + constantes.LOGIN + `/${usuario}/${contrasena}`);
  }

  public generarCodigoSMS(sessionDto: SessionDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.GENERAR_CODIGO_VERIFICACION, sessionDto, this.respuesta);
  }

  public validarCodigoSMS(peticion: ValidarUsuarioDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.VERIFICACION_CODIGO_SMS, peticion, this.respuesta);
  }

  public validarUsuarioParaRecuperarContrasena(usuario: string): Observable<GenericDto> {
    return this.http.get<GenericDto>(environment.api + constantes.VALIDAR_USUARIO_PARA_RECUPERAR_CONTRASENA + `/${usuario}`);
  }

  public actualizarContrasena(actualizarDto: ActualizarContraseñaDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.ACTUALIZAR_CONTRASENA, actualizarDto, this.respuesta);
  }
}
